// src/firebase.ts
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getAnalytics } from 'firebase/analytics';

// Firebase configuration for production environment
const productionConfig = {
  apiKey: "AIzaSyBVWMYhyM_hSJ8EMoQVUnPFHbeOJL0CvvU",
  authDomain: "t1-mobile.firebaseapp.com",
  projectId: "t1-mobile",
  storageBucket: "t1-mobile.firebasestorage.app",
  messagingSenderId: "1028760968963",
  appId: "1:1028760968963:web:d74baf7589d2a0c81d1336",
  measurementId: "G-H71GRE05FL"
};

// Firebase configuration for staging environment
const stagingConfig = {
  apiKey: "AIzaSyBuacCc3rFsfnsNPFTKjjU5s6oWwZQXWsw",
  authDomain: "staging-t1fxteam.firebaseapp.com",
  projectId: "staging-t1fxteam",
  storageBucket: "staging-t1fxteam.firebasestorage.app",
  messagingSenderId: "660875950010",
  appId: "1:660875950010:web:675395ca6597e571cb0f83"
};

// Determine which configuration to use based on environment
// REACT_APP_ENVIRONMENT can be set to 'production', 'staging', or 'development'
const getFirebaseConfig = () => {
  const environment = process.env.REACT_APP_ENVIRONMENT || 'production';
  
  console.log(`Initializing Firebase with ${environment} environment`);
  
  switch(environment) {
    case 'staging':
      return stagingConfig;
    case 'production':
    default:
      return productionConfig;
  }
};

// Initialize Firebase with appropriate configuration
const app = initializeApp(getFirebaseConfig());
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);
const analytics = getAnalytics(app);

// Log Firebase initialization for debugging
const environment = process.env.REACT_APP_ENVIRONMENT || 'production';
console.log(`Firebase initialized with ${environment} environment: ${app.options.projectId}`);

// Connect to Functions emulator if in development
if (process.env.NODE_ENV === 'development') {
  connectFunctionsEmulator(functions, 'localhost', 5001);
}

export { auth, db, functions, analytics };